// useRef code added in many lines to hide key board - 02-08-2024 -Dev Srini
import {
    NumberFormat as NumberFormatBase,
    NumericFormat,
    PatternFormat,
    getNumericCaretBoundary,
    getPatternCaretBoundary,
    numericFormatter,
    patternFormatter,
    removeNumericFormat,
    removePatternFormat,
    useNumericFormat,
    usePatternFormat,
  } from 'react-number-format';
  
  import { forwardRef, useImperativeHandle, useRef } from 'react';
  import TextField from '@mui/material/TextField';
  import { useMediaQuery } from '@mui/material';
  
  // Reset amount - 23-07-24 - Dev Srini
  const RupeeTextField = forwardRef(({ handleAmountValueChange, amount }, ref) => { 
    const inputRef = useRef(null);
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'))

    useImperativeHandle(ref, () => ({
      blurInput: () => {
        if (inputRef.current) {
          inputRef.current.blur();
        }
      }
    }));

    return (
      <NumericFormat
        customInput={TextField}
        inputRef={inputRef}
        inputProps={{
          style : {
            color : "#000000",
            fontSize : "15px"
          }
        }}
        size='small'
        fullWidth
        thousandSeparator={true}
        sx={{
          height : "40px",
          backgroundColor : "#FFFFFF",
          marginLeft : isSmallScreen ? "18px" : "0px",
          marginTop : `10px`, 
          borderRadius : "5px",
          "& .MuiOutlinedInput-notchedOutline": { border: "none" }}}
        prefix={'₹ '}
        value={amount} // Reset amount - 23-07-24 - Dev Srini
        onChange={(event) => handleAmountValueChange(event.target.value)}
        placeholder="Enter Rupee Amount"
      />
    );
  });
  
  export default RupeeTextField;
  